import React, { useState, useEffect } from 'react';
import axios from '../../axios';
import { Form, Button, Container, Table, Modal, Row, Col, Alert } from 'react-bootstrap';
import SearchHeader from './SearchHeader'; // Import SearchHeader

const StudentSearch = () => {
  const [search, setSearch] = useState('');
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null); // State để lưu thông tin sinh viên được chọn
  const [showModal, setShowModal] = useState(false); // State để điều khiển việc hiển thị modal
  const [error, setError] = useState(''); // State để lưu thông báo lỗi
  const [configContent, setConfigContent] = useState(''); // State để lưu nội dung cấu hình
  const [footerContent, setFooterContent] = useState(''); 

  useEffect(() => {
    fetchConfigContent();
    fetchFooterContent();
  }, []);

  const fetchConfigContent = async () => {
    try {
      const res = await axios.get('/configurations/key/chu-y');
      setConfigContent(res.data.configValue);
    } catch (err) {
      setConfigContent('');
      console.error(err);
    }
  };

  const fetchFooterContent = async () => {
    try {
      const res = await axios.get('/configurations/key/footer');
      setFooterContent(res.data.configValue);
    } catch (err) {
      setFooterContent('');
      console.error(err);
    }
  };
  
  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.get('/students/search', {
        params: { search }
      });
      if (res.data.length === 0) {
        setError('Không tìm thấy bản ghi nào.');
      } else {
        setError('');
      }
      setStudents(res.data.slice(0, 10)); // Chỉ hiển thị tối đa 10 kết quả
    } catch (err) {
      console.error(err);
    }
  };

  const handleRowClick = (student) => {
    setSelectedStudent(student);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedStudent(null);
  };

  // Hàm định dạng ngày
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <>
      <SearchHeader /> {/* Sử dụng SearchHeader */}
      <Container className="mt-4">
        <Row className="justify-content-center mb-4">
          <Col md={8} className="text-center">
            <h2>Tra cứu thông tin trúng tuyển - Trường Đại học Công đoàn (LDA)</h2>
            <p>Nhập số báo danh hoặc số CCCD hoặc họ và tên để tra cứu.</p>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md={6}>
            <Form onSubmit={handleSearchSubmit} className="mb-3">
              <Form.Group controlId="formSearch">
                <Form.Control
                  type="text"
                  placeholder="Nhập số báo danh, CCCD hoặc họ tên"
                  value={search}
                  onChange={handleSearchChange}
                />
              </Form.Group>
              <Button variant="primary" type="submit" className="w-100">
                Tìm kiếm
              </Button>
            </Form>
            {error && <Alert variant="warning">{error}</Alert>}
          </Col>
        </Row>
        {students.length > 0 && (
          <Row className="justify-content-center">
            <Col md={10}>
              <Table striped bordered hover className="mt-3">
                <thead>
                  <tr style={{ verticalAlign: 'top', textAlign: 'center' }}> {/* Căn dòng header cột */}
                    <th>Mã sinh viên</th>
                    <th>Số báo danh</th>
                    <th style={{ width: '20%' }}>Họ tên</th> {/* Tăng độ rộng của cột "Họ tên" */}
                    <th>Ngày nhập học</th> {/* Thay đổi tên cột */}
                    <th style={{ width: '30%' }}>Địa điểm nhập học</th> {/* Tăng gấp đôi độ rộng của cột "Địa điểm nhập học" */}
                  </tr>
                </thead>
                <tbody>
                  {students.map((student) => (
                    <tr key={student._id} onClick={() => handleRowClick(student)} style={{ cursor: 'pointer' }}>
                      <td style={{ color: 'red', fontWeight: 'bold', textAlign: 'center' }}>{student.studentId}</td> {/* Mã sinh viên màu đỏ đậm và căn giữa */}
                      <td style={{ textAlign: 'center' }}>{student.examNumber}</td> {/* Căn giữa cột số báo danh */}
                      <td>{student.name}</td>
                      <td style={{ textAlign: 'center' }}>{formatDate(student.expectedEnrollmentDate)}</td> {/* Căn giữa cột ngày nhập học */}
                      <td>{student.expectedEnrollmentLocation}</td> {/* Hiển thị đầy đủ địa điểm nhập học */}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </Row>
        )}

        {/* Vùng lưu ý */}
        <Row className="justify-content-center mt-4">
          <Col md={10}>
            <div dangerouslySetInnerHTML={{ __html: configContent }} />
          </Col>
        </Row>

        {/* Chân trang */}
        <Row className="justify-content-center mt-4">
          <Col md={12}> {/* Thay đổi md={10} thành md={12} để chiếm toàn bộ chiều rộng */}
            <div dangerouslySetInnerHTML={{ __html: footerContent }} />
          </Col>
        </Row>

        {/* Modal để hiển thị thông tin chi tiết sinh viên */}
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Chi tiết sinh viên</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {selectedStudent && (
              <div>
                <p><strong>Mã sinh viên:</strong> {selectedStudent.studentId}</p>
                <p><strong>Số báo danh:</strong> {selectedStudent.examNumber}</p>
                <p><strong>Họ tên:</strong> {selectedStudent.name}</p>
                <p><strong>Số CCCD:</strong> {selectedStudent.citizenId}</p>
                <p><strong>Ngày sinh:</strong> {formatDate(selectedStudent.birthDate)}</p>
                <p><strong>Mã ngành:</strong> {selectedStudent.majorCode}</p>
                <p><strong>Ngành:</strong> {selectedStudent.majorName}</p>
                <p><strong>Mã phương thức xét tuyển:</strong> {selectedStudent.admissionMethodCode}</p>
                <p><strong>Thứ tự nguyện vọng:</strong> {selectedStudent.admissionOrder}</p>
                <p><strong>Ngày nhập học:</strong> {formatDate(selectedStudent.expectedEnrollmentDate)}</p>
                <p><strong>Địa điểm nhập học:</strong>
                  {selectedStudent.expectedEnrollmentLocation}</p>
                <p><strong>Ghi chú:</strong> {selectedStudent.notes}</p>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Đóng
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </>
  );
};

export default StudentSearch;
